import type { SaveProjectConfigData } from 'types/apis/pilotInterfaces';

/**
 * Stable key for matching registry rows across the "user/METADATA batch" and "default values" batch saves.
 */
export function makeProjectConfigRegistryKey(configType: string, configKey: string): string {
  return `${configType}|${configKey}`;
}

/**
 * Collects all `config_type|config_key` pairs from a first save payload (e.g. `allToSave`).
 */
export function collectKeysFromSavePayload(
  rows: Pick<SaveProjectConfigData, 'config_type' | 'config_key'>[]
): Set<string> {
  const set = new Set<string>();
  for (const row of rows) {
    set.add(makeProjectConfigRegistryKey(row.config_type, row.config_key));
  }
  return set;
}

/**
 * When true, skip saving a registry default for this row — the same key was already persisted
 * in the first batch (prevents overwriting user input / METADATA with `defaultValue`).
 */
export function shouldSkipDefaultConfigDuplicate(
  firstBatchKeys: Set<string>,
  configType: string,
  configKey: string
): boolean {
  return firstBatchKeys.has(makeProjectConfigRegistryKey(configType, configKey));
}
